module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-MdIt.50c9a03.woff";